module.exports = __webpack_public_path__ + "img/7_26@3x.4f98b7a0.png";